import bookingStyles from './BookingWidget.module.css';

type BookingWidgetStyles = {
  statusConfirmed: string;
  statusProcessing: string;
  statusFailed: string;
};

export const bookingWidgetStyles = bookingStyles as BookingWidgetStyles;
